export type SnapshotTeam = {
  readonly team_id: number;
  readonly team_name: string;
};

/** Keep server team order and row order; every row belongs to exactly one group. */
export function groupSnapshotTeams<
  T extends { readonly team_id?: number | null },
>(teams: readonly SnapshotTeam[], rows: readonly T[]) {
  const known = new Set(teams.map((team) => team.team_id));
  return [
    ...teams.map((team) => ({
      ...team,
      nurses: rows.filter((row) => row.team_id === team.team_id),
    })),
    {
      team_id: null,
      team_name: "미등록",
      nurses: rows.filter(
        (row) => row.team_id == null || !known.has(row.team_id)
      ),
    },
  ];
}
